import React from 'react';
import { AvInput } from 'availity-mobx-reactstrap-validation';
import { observer } from 'mobx-react';
import { Spring, animated, config } from 'react-spring';

import { lightGrey1Color } from 'js/config/style';
import analytics from 'js/services/Analytics';
import EmailPreferencesPageState from 'js/stores/pages/EmailPreferencesPageState';

import AppContent from 'js/components/AppContent';
import PageComponent from 'js/components/pages/PageComponent';

import Backdrop from 'js/components/core/Backdrop';
import Constraint from 'js/components/Constraint';
import ErrorDisplay from 'js/components/common/ErrorDisplay';

import Title from './Title';
import AvForm from './AvForm';
import AvGroup from './AvGroup';
import Label from './Label';
import Text from './Text';
import Button from './Button';
import TitleIcon from './TitleIcon';

import { startAnimation, endAnimation } from 'js/config/style';
const offset = '7.75rem';

@observer
export default class EmailPreferencesPage extends PageComponent {
  pageName = 'EmailPreferencesPage';
  loginRequired = true;
  pageColor = lightGrey1Color;
  emailPreferencesPage = EmailPreferencesPageState.create();

  bootstrap = () => {
    //analytics.page('Email Preferences');
    return this.emailPreferencesPage.load();
  };

  renderPage() {
    const { isSaving, wasSaved, save, preferences, error } = this.emailPreferencesPage;
    return (
      <AppContent>
        <Backdrop offset={offset}>
          <Constraint>
            <Title>Email preferences</Title>
          </Constraint>
        </Backdrop>

        <Constraint offset={offset}>
          <Spring native from={startAnimation} to={endAnimation} config={config.gentle}>
            {animation => (
              <animated.div style={animation}>
                <AvForm onValidSubmit={save}>
                  <TitleIcon name="envelope" />
                  {preferences.map(preference => (
                    <AvGroup check key={preference.name}>
                      <Label check>
                        <AvInput
                          type="checkbox"
                          name={preference.name}
                          value={preference.is_receiving}
                          onChange={preference.setIsReceiving}
                        />
                        <Text>{preference.label}</Text>
                      </Label>
                    </AvGroup>
                  ))}

                  <ErrorDisplay>{error}</ErrorDisplay>

                  <Button type="submit" isLoading={isSaving}>
                    {isSaving ? 'Saving...' : wasSaved ? 'Saved!' : 'Save'}
                  </Button>
                </AvForm>
              </animated.div>
            )}
          </Spring>
        </Constraint>
      </AppContent>
    );
  }
}
